import api from './api';

/**
 * EDI Inventory Adjustments (cms.edi_inventoryadj) — the sent/unsent + delete/undelete
 * action. The grid (read-only /tablemaint engine, key 'edi-inventory-adj') shows the
 * inventory-adjustment EDI transactions; this only ever sets the Sent Date
 * (edisentdatetime) and/or Deleted flag on a single row. There is no archive table.
 */
export async function updateEdiInventoryAdj(
  recno: number,
  patch: { edisentdatetime?: string; deleted?: string },
): Promise<void> {
  await api.put(`/edi-inventory-adj/${recno}`, patch);
}
